export const runbookSystemConstants = {
  GET_ALL_REQUEST: "GET_ALL_RUNBOOKSYSTEM_REQUEST",
  GET_ALL_SUCCESS: "GET_ALL_RUNBOOKSYSTEM_SUCCESS",
  GET_ALL_FAILURE: "GET_ALL_RUNBOOKSYSTEM_FAILURE",

  GET_REQUEST: "GET_RUNBOOKSYSTEM_REQUEST",
  GET_SUCCESS: "GET_RUNBOOKSYSTEM_SUCCESS",
  GET_FAILURE: "GET_RUNBOOKSYSTEM_FAILURE",

  GET_BY_ID_REQUEST: "GET_RUNBOOKSYSTEM_BY_ID_REQUEST",
  GET_BY_ID_SUCCESS: "GET_RUNBOOKSYSTEM_BY_ID_SUCCESS",
  GET_BY_ID_FAILURE: "GET_RUNBOOKSYSTEM_BY_ID_FAILURE",

  CREATE_REQUEST: "CREATE_RUNBOOKSYSTEM_REQUEST",
  CREATE_SUCCESS: "CREATE_RUNBOOKSYSTEM_SUCCESS",
  CREATE_FAILURE: "CREATE_RUNBOOKSYSTEM_FAILURE",

  UPDATE_REQUEST: "UPDATE_RUNBOOKSYSTEM_REQUEST",
  UPDATE_SUCCESS: "UPDATE_RUNBOOKSYSTEM_SUCCESS",
  UPDATE_FAILURE: "UPDATE_RUNBOOKSYSTEM_FAILURE",

  DELETE_REQUEST: "DELETE_RUNBOOKSYSTEM_REQUEST",
  DELETE_SUCCESS: "DELETE_RUNBOOKSYSTEM_SUCCESS",
  DELETE_FAILURE: "DELETE_RUNBOOKSYSTEM_FAILURE",
};
